
webpack.register(
    'modules/history-experience-scoring-and-stats/tabs/tabs',
    function() {
        return import('modules/history-experience-scoring-and-stats/tabs/tabs');
    },
    true
);